import { useAuthStore } from '@/stores/auth';
import type { Character } from '@/types/database';

/**
 * Returns the current user's character or null if signed out / not yet
 * created / not yet loaded. The auth store keeps this in sync with auth
 * state changes; call useAuthStore.getState().refreshCharacter() after
 * mutating character rows.
 */
export function useCharacter(): Character | null {
  return useAuthStore((s) => s.character);
}
